import React, { FC, ReactNode, useEffect, useState } from 'react';
import { TbArrowUpRight, TbCalendarShare, TbMailShare } from 'react-icons/tb';

interface OurDocsLinkProps {
    text?: any;
    href?: any;
    type?: 'docs' | 'email' | 'calendar';
}

const OurDocsLink: FC<OurDocsLinkProps> = ({
    text = 'our docs',
    href = 'https://docs.countercyclical.io',
    type = 'docs',
}): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    // !IMPORTANT: Refactor to useMaps()
    const map = {
        docs: <TbArrowUpRight style={{ verticalAlign: '-0.1rem', marginLeft: '0.125rem' }} />,
        email: <TbMailShare style={{ verticalAlign: '-0.1rem', marginLeft: '0.125rem' }} />,
        calendar: <TbCalendarShare style={{ verticalAlign: '-0.1rem', marginLeft: '0.125rem' }} />,
    } as Record<typeof type, ReactNode>;

    return (
        <a href={href} target='_blank' rel='noopener noreferrer'>
            {text}
            {map[type]}
        </a>
    );
};

export default OurDocsLink;
